import { Button, DatePicker, Space } from 'antd'
import dayjs from 'dayjs'
import React, { useEffect } from 'react'

const DateSearch = ({ type, setType, startDate, setStartDate, endDate, setEndDate }) => {


	return (
		<Space.Compact size="small">
			<DatePicker
				showTime={{
					defaultValue: dayjs('00:00:00', 'HH:mm:ss'),
				}}
				format="YYYY-MM-DD HH:mm:ss"
				allowClear={true}
				onChange={e => {
					setStartDate(
						e
							? dayjs(e, 'YYYY-MM-DD HH:mm:ss').format(
									'YYYY-MM-DD HH:mm:ss'
							  )
							: undefined
					)

					setType(3)
				}}
				value={
					startDate
						? dayjs(startDate, 'YYYY-MM-DD HH:mm:ss')
						: undefined
				}
			/>
			<DatePicker
				showTime={{
					defaultValue: dayjs('00:00:00', 'HH:mm:ss'),
				}}
				format="YYYY-MM-DD HH:mm:ss"
				allowClear={true}
				onChange={e => {
					setEndDate(
						e
							? dayjs(e, 'YYYY-MM-DD').format(
									'YYYY-MM-DD HH:mm:ss'
							  )
							: undefined
					)

					setType(3)
				}}
				value={
					endDate ? dayjs(endDate, 'YYYY-MM-DD HH:mm:ss') : undefined
				}
			/>
			<Button
				onClick={() => {
					const now = dayjs()
					setStartDate(
						now.subtract(7, 'day').format('YYYY-MM-DD 06:00:00')
					)
					setEndDate(now.format('YYYY-MM-DD 23:59:59'))
					setType(0)
				}}
				type={type === 0 ? 'primary' : 'default'}
				size="small">
				7일
			</Button>
			<Button
				onClick={() => {
					const now = dayjs()
					setStartDate(
						now.subtract(30, 'day').format('YYYY-MM-DD 06:00:00')
					)
					setEndDate(now.format('YYYY-MM-DD 23:59:59'))
					setType(1)
				}}
				type={type === 1 ? 'primary' : 'default'}
				size="small">
				30일
			</Button>
			<Button
				onClick={() => {
					setStartDate(null)
					setEndDate(null)
					setType(2)
				}}
				type={(!startDate && !endDate) ? 'primary' : 'default'}
				size="small">
				전체
			</Button>
		</Space.Compact>
	)
}

export default React.memo(DateSearch)
